exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sub[data-v-63346463]{margin-top:30px;display:inline-block}textarea[data-v-63346463]{resize:none;height:86px;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-63346463","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/gestionDesAbsences/modals/modalChangerEtatAbsence/modalChangerEtatAbsence.scss
// module id = t4BK
// module chunks = 2